export default __webpack_public_path__ + "static/media/two_tou1.3735864b.png";